import { Text } from 'slate';
import convertPathToOffset from './convertPathToOffset';
export default function getOperationOffset(op, _ref) {
  var value = _ref.value;
  var node = value.document.getNode(op.path);

  if (Text.isText(node)) {
    return convertPathToOffset(value.document, op.path, op.offset || op.position || 0);
  } else {
    return convertPathToOffset(value.document, op.position ? op.path.push(op.position) : op.path, op.offset || 0);
  }
}